interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
}

export default function SectionHeading({
  kicker,
  title,
  desc,
  align = 'left',
  tone = 'light',
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'text-center max-w-2xl mx-auto' : 'max-w-2xl'}>
      <span
        className={`inline-flex items-center gap-2 text-xs font-label tracking-[0.22em] uppercase ${
          tone === 'dark' ? 'text-accent-300' : 'text-primary-600'
        }`}
      >
        <i className="ri-price-tag-3-line"></i>
        {kicker}
      </span>
      <h2
        className={`mt-3 font-heading text-2xl md:text-4xl font-bold leading-snug ${
          tone === 'dark' ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            tone === 'dark' ? 'text-background-200' : 'text-foreground-600'
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}